import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';

@withText(props => ({
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
}))
@observer
class StreamEdit extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('stream'),
        };
    }

    loadAll = async (props = this.props, emptyFirst = true) => {
        const { id, race, isNew, initialData } = props;
        const { streamStore } = this.props.stores;
        if (emptyFirst) {
            streamStore.updateKeyValue('stream', {});
            // When creating new stream, pre-populate with initialData or race if provided
            if (isNew && initialData) {
                streamStore.updateKeyValue('newStream', { ...initialData });
            } else if (isNew && race) {
                streamStore.updateKeyValue('newStream', { race });
            } else if (isNew) {
                // Keep existing newStream data (may have been pre-populated by caller)
                // Only reset if it's truly empty
                const { newStream } = streamStore;
                if (!newStream || Object.keys(newStream).length === 0) {
                    streamStore.updateKeyValue('newStream', {});
                }
            } else {
                streamStore.updateKeyValue('newStream', {});
            }
        }
        if (id) {
            await streamStore.load(id, false, {});
        }
    }

    createStream = async () => {
        const { callback = () => {}, id, isNew, drawerLevel } = this.props;
        const { streamStore, appState } = this.props.stores;
        const { newStream } = streamStore;

        if (isNew) {
            const response = await streamStore.insert({
                ...newStream,
            });
            streamStore.updateKeyValue('stream', response?.data?.stream);
            streamStore.updateKeyValue('newStream', {});
            callback();
            appState.toggleDrawer(false, drawerLevel);
        }
    }

    componentDidMount() {
        this.loadAll();
    }

    render() {
        const { week, isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, streamStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newStream, stream } = streamStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center position-relative'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        {isNew ? <Text id='stream.new'>New stream</Text> : <Text id='stream.edit'>Edit stream</Text>}
                    </div>

                    <div class='w-100 d-flex flex-column justify-content-start'>
                        <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                            <FormFieldsCompact
                                stores={this.props.stores}
                                sections={sections}
                                holdingStore={streamStore}
                                objectName={isNew ? 'newStream' : 'stream'}
                                isNew={isNew}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                                hideFilterToolbar={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                <button type='button' class='btn btn-primary rounded-pill' onClick={this.createStream}>
                    {isNew ? <Text id='stream.create'>Create stream</Text> : <Text id='stream.save'>Save stream</Text>}
                </button>
            </div>}
        </>);
    }
}

export default StreamEdit;
